export type TextSize = 'default' | 'large' | 'larger';

// Opt-in larger text and spacing (issue #319): one multiplier for the whole
// web app, applied as CSS zoom on the root so type and spacing scale
// together and nothing falls below the 14px / 44px floors. The default
// experience is unchanged (1).
const STEPS: Record<TextSize, { label: string; zoom: number; next: TextSize }> = {
  default: { label: 'Default', zoom: 1, next: 'large' },
  large: { label: 'Large', zoom: 1.15, next: 'larger' },
  larger: { label: 'Larger', zoom: 1.3, next: 'default' },
};

export const textSizeZoom = (size: TextSize): number => STEPS[size].zoom;
export const textSizeLabel = (size: TextSize): string => STEPS[size].label;
export const nextTextSize = (size: TextSize): TextSize => STEPS[size].next;

export function parseTextSize(raw: string | null | undefined): TextSize {
  return raw === 'large' || raw === 'larger' ? raw : 'default';
}
